import isString from "lodash/isString";

export function isValidPassword(password) {
    return isString(password) && password.length >= 8;
}

/**
 * Implements really simple email address validation. `email` is an email address if it's a string that consists of one
 * or more non-whitespace characters followed by an @ sign followed by 1 or more characters. According to this function,
 * `a@a` is a valid email address.
 * @param email a value to test for valid email-ness
 * @returns {boolean} true if `email` is a valid email address and false if it's not.
 */
export function isValidEmail(email) {
    return isString(email) && !!email.trim().match(/\S+@\S+/);
}



// WEBPACK FOOTER //
// ./src/modules/user/utils.js